import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import { formatCpfCnpj, formatPhone } from "../helpers/format";

const CheckUserNumber = ({
  open,
  onClose,
  onSubmit,
  user,
}: {
  open: boolean;
  user: any;
  onClose: () => void;
  onSubmit: () => void;
}) => (
  <Dialog maxWidth="xs" open={open} fullWidth>
    <DialogContent>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          <Typography variant="h2" fontSize={26} fontWeight={600}>
            Telefone já cadastrado
          </Typography>
        </Grid2>

        <Grid2 size={12}>
          <Typography variant="body1" color="secondary.contrastText">
            O número de telefone informado já está associado ao usuário abaixo.
            Por favor, confirme as informações ou forneça um novo número.
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Stack
            padding={"0.5rem"}
            sx={{ backgroundColor: "#161616", borderRadius: "1rem" }}
            flexDirection={"row"}
            gap="1rem"
            alignItems={"center"}
          >
            <Stack padding={"0.3rem"}>
              <Typography fontWeight={700} variant="subtitle1">
                {user?.name}
              </Typography>
              <Typography variant="body2" color="secondary.contrastText">
                {formatPhone(user?.phone)}
              </Typography>
              <Typography variant="body2" color="secondary.contrastText">
                {formatCpfCnpj(user?.document)}
              </Typography>
              <Typography variant="body2" color="secondary.contrastText">
                {user?.email}
              </Typography>
            </Stack>
          </Stack>
        </Grid2>
      </Grid2>
    </DialogContent>
    <DialogActions>
      <Stack
        flexDirection={"column"}
        sx={{ width: "100%" }}
        gap="1rem"
        paddingX="1rem"
        paddingBottom={"1rem"}
      >
        <Button variant="contained" size="large" fullWidth onClick={onSubmit}>
          Sim, é esse úsuario
        </Button>

        <Button
          fullWidth
          variant="text"
          sx={{ color: "#fff" }}
          size="large"
          onClick={onClose}
        >
          Quero trocar o telefone
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>
);

export default CheckUserNumber;
